import {PatientInformationDialog} from '@/modules/patients/components/dialogs/patient-information-dialog'
import {Patient} from '@cypro/engine/schema'
import {dialog} from '@cypro/ui/components'

export function openPatientInformationDialog(patient: Patient) {
  return dialog.open('patient-information', {
    children: <PatientInformationDialog patient={patient} />,
  })
}
